import { z } from 'zod';
/**
 * Enums / types du domaine T1 — source unique de vérité front + back.
 * Chaque enum est déclaré comme schéma Zod (validation) ET exporté comme type
 * dérivé. Les valeurs sont alignées sur ADR-0002 et sur les enums PostgreSQL
 * créés par la migration `0001_init.sql`.
 */
/** Nature d'un média. */
export const assetKindSchema = z.enum(['image', 'video']);
/** Rôle utilisateur. */
export const userRoleSchema = z.enum(['superadmin', 'admin', 'user']);
/** Langue de l'interface (i18n UI). */
export const localeSchema = z.enum(['fr', 'de', 'en']);
/** Préférence de thème (défaut applicatif : `system`). */
export const themeSchema = z.enum(['light', 'dark', 'system']);
/** Type de job asynchrone. */
export const jobTypeSchema = z.enum([
    'scan',
    'thumbnail',
    'ai_tag',
    'dedup',
    'dedup_apply',
    'dedup_exact_apply',
    'exif_publish',
    'exif_erase',
    'move',
    'compress',
    'rotate',
    'originals_cleanup',
    'trash_purge',
    'rename_extensions',
    'empty_folders_cleanup',
]);
/** Statut d'un job dans la file. */
export const jobStatusSchema = z.enum(['queued', 'running', 'done', 'failed', 'canceled']);
//# sourceMappingURL=enums.js.map